<template>
  <v-container>
    <!--The Side Menu component go here -->
    <v-toolbar fixed dark color="primary" class="elevation-2">
      <v-toolbar-title class="white--text">🎬 Movie Mash</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" persistent max-width="290">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
            <v-icon color="primary" dark v-bind="attrs" v-on="on"
              >mdi-information</v-icon
            >
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline"> About this site </v-card-title>
          <v-card-text
            >This product uses the TMDb API but is not endorsed or certified by
            TMDb
            <v-img
              contain
              height="80px"
              width="80px"
              src="https://www.themoviedb.org/assets/2/v4/logos/v2/blue_square_2-d537fb228cf3ded904ef09b136fe3fec72548ebc1fea3fbbd1ad9e36364db38b.svg"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark text @click="dialog = false"> Close </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-main>
      <v-container data-app fluid>
        <!--The Main Content component go here-->
        <MainContent />
      </v-container>
    </v-main>
  </v-container>
</template>

<script>
import MainContent from "./components/MainContent.vue"; // import the Main Content component
export default {
  mounted() {},
  components: {
    MainContent, // Register the component
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>